import { Controller } from 'stimulus'

const EVERY_MS  = 2500
const GIVE_UP_MS = 5 * 60 * 1000

export default class extends Controller {
  static targets = ['drafts', 'count', 'spinner', 'status']

  connect() {
    this.expected = parseInt(this.data.get('expected'), 10) || 0
    this.baseline = parseInt(this.data.get('baseline'), 10) || 0
    if (this.expected <= 0) return

    this.startedAt = Date.now()
    this.render(this.baseline)
    this.spinnerTarget.hidden = false
    this.timer = setInterval(() => this.poll(), EVERY_MS)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  poll() {
    if (Date.now() - this.startedAt > GIVE_UP_MS) return this.stop()

    fetch('/back_office/announcements/drafts_status', {
      credentials: 'same-origin',
      headers:     { 'Accept': 'application/json' },
    })
      .then(res => res.json())
      .then(({ count, html }) => {
        this.draftsTarget.innerHTML = html
        this.countTarget.textContent = `(${count})`
        const written = count - this.baseline
        this.render(count)
        if (written >= this.expected) this.stop()
      })
      .catch(() => {})
  }

  render(count) {
    const written = Math.max(count - this.baseline, 0)
    this.statusTarget.textContent = I18n.t('announcements.back_office.index.writing_progress', {
      done: written, total: this.expected,
    })
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
    this.spinnerTarget.hidden = true
    // Clear ?writing= so a later reload does not poll again.
    const url = new URL(window.location)
    url.searchParams.delete('writing')
    history.replaceState(history.state, document.title, url.href)
  }
}
